import { render, staticRenderFns } from "./ResultA.vue?vue&type=template&id=1ff69cae&"
import script from "./ResultA.vue?vue&type=script&lang=js&"
export * from "./ResultA.vue?vue&type=script&lang=js&"
import style0 from "./ResultA.vue?vue&type=style&index=0&id=1ff69cae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports